import { createContext } from "react"
import type { ProjectProps } from "@/halSources"

interface PlmContextValues{
    onProjectChange?: (v: ProjectProps)=>void;
}

export const PlmContext = createContext<PlmContextValues>({});

interface GlobalContextValues {
    user?: API.USER.Me;
}
export const GlobalContext = createContext<GlobalContextValues>({})